import { useMemo, useState, useRef, useEffect } from 'react';
import TabComponent from './tabs';
import { useGetConfig } from '../../useGetConfig';
import ossImgCompress from '@/utils/ossImgCompress';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import styles from './mo.module.less';
import { ProductTracker } from '@/utils/Tracker';
import LazyLoadImg from '@/components/LazyLoadImg';

const AccessoryCarouselMO = () => {
  const {
    SPECIAL_COMMODITY,
    mobxStore: { product, area },
    skipIndex,
    commodityAccessoryList,
    mobxStore: {
      app: { webp },
    },
  } = useGetConfig();
  const { LANG } = area;
  const { curSelectCommodityId: cid, productDetail, curSelectCommodity } = product;
  const [activeKey, setActiveKey] = useState<number>(1);

  useEffect(() => {
    if (typeof skipIndex === 'number') {
      setActiveKey(2);
    }
  }, [skipIndex]);

  const getTabItems = useMemo(() => {
    const items = [
      {
        label: LANG['productNew.Display.mo_accessories_tab1_name'],
        key: 1,
        children: <div></div>,
        trackerEvent: () => {},
      },
      {
        label: LANG['productNew.Display.mo_accessories_tab2_name'],
        key: 2,
        children: <Accessories />,
        trackerEvent: () => {
          ProductTracker.productPageImages({
            action: 'click_accessory_tab',
            category: 'product_image',
            data: {
              url_key: productDetail?.url_key,
              name: curSelectCommodity?.name,
              id: cid,
            },
          });
        },
      },
    ];
    /** 特殊套餐只展示一个 */
    return SPECIAL_COMMODITY.has(cid) ? items.slice(0, -1) : items;
  }, [cid]);

  return (
    <div
      className={styles.accessory}
      data-hidden-background-image={activeKey}
      style={{
        backgroundImage: `url(${ossImgCompress(commodityAccessoryList[0]?.sceneGraph_url ?? '', { webp })})`,
        backgroundSize: 'contain',
        backgroundPosition: 'center',
      }}
    >
      <div className={styles.tabs}>
        <TabComponent activeKey={activeKey} setActiveKey={setActiveKey} items={getTabItems} />
      </div>
    </div>
  );
};

export default AccessoryCarouselMO;

const Accessories = () => {
  const {
    commodityAccessoryList,
    mobxStore: {
      app: { isMobile },
    },
    skipIndex,
  } = useGetConfig();
  const splideRef = useRef<Splide | null>(null);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (typeof skipIndex === 'number') {
      splideRef.current?.splide?.go(skipIndex);
    }
  }, [skipIndex]);
  // slice(1) 移动端轮播区域去掉合集
  const cAccessoryList = commodityAccessoryList.slice(1);

  return (
    <div className={styles.accessories}>
      <Splide
        options={{
          type: 'fade',
          pagination: false,
          arrows: false,
          autoplay: false,
          rewind: true,
          resetProgress: false,
          pauseOnHover: true,
          pauseOnFocus: true,
          interval: 1500,
        }}
        ref={splideRef}
        onMove={(splide, newIndex) => {
          if (newIndex > activeIndex) {
            ProductTracker.productPageImages({
              action: 'drag_accessories_right',
              category: 'product_image',
              data: {},
            });
          } else if (newIndex < activeIndex) {
            ProductTracker.productPageImages({
              action: 'drag_accessories_left',
              category: 'product_image',
              data: {},
            });
          }
          setActiveIndex(newIndex);
        }}
        className={styles.container}
      >
        {cAccessoryList.map((item, index) => {
          return (
            <SplideSlide key={`step-${index}`}>
              <div className={styles.content}>
                <LazyLoadImg
                  src={isMobile ? item.sceneGraph_url_mo : item.sceneGraph_url}
                  className={styles.img}
                  ratio={[342, 186]}
                  alt=''
                />
                <p className={styles.title}>{item.accessory_name}</p>
                <div className={styles.desc}>
                  <p>{item.accessory_desc}</p>
                </div>
              </div>
            </SplideSlide>
          );
        })}
      </Splide>
      <div className={styles.customizePagination}>
        {cAccessoryList.map((item, idx) => {
          return <div className={styles.origin} key={idx} data-active={activeIndex === idx}></div>;
        })}
      </div>
    </div>
  );
};
